module.exports = __webpack_public_path__ + "static/media/mBennet.6bee4f2b.jpeg";